<template>
  <span
    class="chip px-2 fipa-chip"
    v-bind="$attrs"
    :class="classListFn($props)"
    :style="customStyleFn($props)"
    :data-test="dataTest"
    v-on="$listeners"
    ><slot />
  </span>
</template>
<script>
export default {
  name: "AppChip",
  props: {
    large: Boolean,
    small: Boolean,
    color: {
      type: String,
      default: null
    },
    textColor: {
      type: String,
      default: null
    },
    customStyle: {
      type: String,
      default: null
    },
    classList: {
      type: [String, Object],
      default: undefined
    },
    dataTest: {
      type: String,
      default: undefined
    }
  },
  methods: {
    customStyleFn: function (props) {
      let styleList = props.customStyle ?? "";
      if (props.color?.includes("#")) {
        styleList += `background-color: ${props.color};`;
      }
      return styleList;
    },
    classListFn: function (props) {
      let obj = {
        [props.color]: true,
        [props.textColor]: true,
        "chip-large": props.large,
        "chip-smaller": props.small
      };

      if (props.color?.includes("#")) {
        obj[props.color] = undefined;
      }

      if (typeof props.classList === "object") {
        obj = { ...obj, ...props.classList };
      } else if (props.classList) {
        obj[props.classList] = true;
      }

      return obj;
    }
  }
};
</script>
<style lang="scss" scoped>
.chip {
  white-space: nowrap;
  display: inline-flex;
  border-radius: 4px;
  align-items: center;
  font-size: 11px;
  height: 16px;
}

.chip-large {
  font-size: 14px;
  white-space: nowrap;
  height: 32px !important;
}

.chip-smaller {
  font-size: 10px;
  white-space: nowrap;
}
</style>
